module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c3b4884ed609e50774104c3fd627b89e.png";